import { MigrationSpec } from "../migration.models"
import actionLegacyChannelScope from "./action_legacy_channel_scope"
import aiAgentSessionDropTtl from "./ai_agent_session_drop_ttl"
import aiEmailSettings from "./ai_email_settings"
import aiEmailSkills from "./ai_email_skills"
import aiMarketplaceGuidance from "./ai_marketplace_guidance"
import aiMarketplaceProfiles from "./ai_marketplace_profiles"
import aiMarketplaceSkills from "./ai_marketplace_skills"
import aiPersonMemoryToSessions from "./ai_person_memory_to_sessions"
import aiProfileChannelScope from "./ai_profile_channel_scope"
import aiProfileRoles from "./ai_profile_roles"
import aiPromptEngineVersions from "./ai_prompt_engine_versions"
import aiPromptRoles from "./ai_prompt_roles"
import aiPromptV1Layer from "./ai_prompt_v1_layer"
import callSnapshotStartedInWH from "./call_snapshot_started_in_wh"
import csatReportMetricTemplates from "./csat_report_metric_templates"
import csatReportWidgetTemplates from "./csat_report_widget_templates"
import customFieldDefaults from "./custom_field_defaults"
import extractContactInfoFlowBlockTemplates from "./extract_contact_info_flow_block_templates"
import extractContactInfoFlowNodeTemplates from "./extract_contact_info_flow_node_templates"
import {
  legacyCampaignFeaturesCustomerProducts,
  legacyCampaignFeaturesProducts
} from "./legacy_campaign_features"
import liveChatWelcomeMessages from "./live_chat_welcome_messages"
import metaAdsFlowBlockTemplates from "./meta_ads_flow_block_templates"
import metaAdsFlowNodeTemplates from "./meta_ads_flow_node_templates"
import metaAdsReportMetricTemplates from "./meta_ads_report_metric_templates"
import metaAdsReportWidgetTemplates from "./meta_ads_report_widget_templates"
import operatorReportingIndexes from "./operator_reporting_indexes"
import personNoteIndexes from "./person_note_indexes"

/**
 * The migrations the page lists. Add a file next to these and list it here — that is the whole
 * procedure. Nothing in api-v2 changes as long as `type` names a OneTimesType that already
 * performs the work. Once one has run in every environment, move it to the archive below.
 */
const MIGRATION_REGISTRY: MigrationSpec[] = [
  actionLegacyChannelScope,
  aiEmailSettings,
  aiEmailSkills,
  aiProfileChannelScope,
  aiPersonMemoryToSessions,
  aiAgentSessionDropTtl,
  ...operatorReportingIndexes,
  personNoteIndexes,
  customFieldDefaults,
  metaAdsFlowNodeTemplates,
  metaAdsFlowBlockTemplates,
  extractContactInfoFlowNodeTemplates,
  extractContactInfoFlowBlockTemplates,
  // Metric templates before widget templates: the widgets reference them.
  metaAdsReportMetricTemplates,
  metaAdsReportWidgetTemplates,
  csatReportMetricTemplates,
  csatReportWidgetTemplates,
  legacyCampaignFeaturesCustomerProducts,
  legacyCampaignFeaturesProducts,
  callSnapshotStartedInWH
]

/**
 * Already run everywhere. Kept rather than deleted: a new environment (or a restored database)
 * still needs them, in this order, and the page probes them only when the archive is opened.
 */
export const ARCHIVED_MIGRATIONS: MigrationSpec[] = [
  aiProfileRoles,
  aiPromptRoles,
  // After the roles migration: it drops the index this one replaces.
  aiPromptEngineVersions,
  aiPromptV1Layer,
  // In this order: the two SAFE ones scope rules to the role the first one creates.
  aiMarketplaceProfiles,
  aiMarketplaceGuidance,
  aiMarketplaceSkills,
  liveChatWelcomeMessages
]

export default MIGRATION_REGISTRY
